import { useTranslations } from 'next-intl';
import { formatPhone } from 'utilities/phone-format';

export const ContactDetails = ({ helpData }) => {
  const t = useTranslations('help');

  return (
    <>
      <div className="flex border-b-2 py-4 headingM justify-center">
        <p className="" data-testid="contact-title-lable">
          {t('contactTitle')}
        </p>
      </div>
      <div className="flex items-center justify-center py-4">
        <a
          href={`tel:${helpData?.phoneNumber}`}
          className="headingMHeavy"
          data-testid="help-contactNumber"
        >
          {formatPhone(helpData?.phoneNumber)}
        </a>
      </div>
      <div className="flex justify-center py-2">
        <span className="bodyHeavyFont mr-2" data-testid="help-contact">
          {t('monFrLabel')}
        </span>
        <span className="bodyFont">{t('monFrTime')}</span>{' '}
      </div>
      <div className="flex justify-center py-2">
        <span className="bodyHeavyFont mr-2">{t('saturdayLabel')}</span>
        <span className="bodyFont">{t('saturdayTime')}</span>
      </div>
      <div className="flex justify-center py-2">
        <span className="bodyHeavyFont mr-2">{t('sundayLabel')}</span>
        <span className="bodyFont">{t('sundayTime')}</span>
      </div>
      <p className="flex justify-center text-SnapBlue py-2">
        <a
          href={`mailto:${helpData?.primaryEmail}`}
          data-testid="help-contactEmail"
        >
          {helpData?.primaryEmail}
        </a>
      </p>
    </>
  );
};
